<!--TelaDeInscricao.svelte-->
<script>
  import { 
    ItemInserir,
    Tipo,
    generateCreateTableSQL,
  } from "../../Classes/ItemInserir";
  import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
  import AccordionItem from "../../componentes_basicos/AccordionItem.svelte";
  import Motivacional from "../../componentes_basicos/Motivacional.svelte";
  import BotaoLixeira from "../../componentes_basicos/BotaoLixeira.svelte";
  import CompiladorDeInserirDados from "../../Componentes/InsercaoDados/CompiladorDeInserirDados.svelte";
  import ArmazenaVariaveisLogin from "../../Classes/ArmazenaVariaveisLogin";
  import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
  import Constantes from "../../Classes/Constantes";
  import InserirDadosAcordion from "../../Componentes/InsercaoDados/InserirDadosAcordion.svelte";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import InputValidacao from "../../componentes_basicos/InputValidacao.svelte";
  import { DadosPaginaAnterior } from "../../Classes/Stores";
  import Conexoes from "../../Classes/Conexoes";
  import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
  import Loading from "../../componentes_basicos/Loading.svelte";
  let permite_chamar_navigate=true; //permitir q o navigate seja chamado só uma vez
  const api_inscricao_campeonato = Constantes.api_inscricao_campeonato;
  const apiEdicaoCadastro = Constantes.api_editar_padrao;
  const apiConsultaCadastro = Constantes.api_consultar_padrao;
  const query_code_inserir_cadastro_nao_logado = "inserir_usuario_nao_logado";
  const query_code_carrega_dados_usuario_cadastrado =
    "carrega_dados_usuario_cadastrado_inscricoes";
  const tabela_cadastro = Constantes.nome_tabela_cadastrar_usuarios_incricao;

  const tela_minhas_inscricoes = "/minhasinscricoes";

  let conexao = new Conexoes();

  let aguardarCarregamentoInicial = false;
  let carregando = true;
  let showPendingMessage = false;

  export let params;
  let id_campeonato = params;

  let tituloAcordion = 'Inscrição';
  let rotuloAcordion = "Cliente";
  let parametrosInputValidacao = {
    query_code: "consulta_cupom",
    id_campeonato: id_campeonato,
  };
  let apiInputValidacao = "consultas.php";
  let voltarPagina = Constantes.tela_pre_inscricao + "?id=" + id_campeonato;
  let precoCategoria = ""; // Unused?
  let numeroAteltas = 0;

  let totalItens = {};
  let rotuloCategoria = "Pacotes";
  let AberturaAccordion = [rotuloCategoria];

  // --- CONFIGURAÇÕES ORIGINAIS DOS ITENS ---
  // Mantemos as configurações originais separadas
  let nomeTimeConfig = [

    /*
    new ItemInserir({
      rotulo: "Nome da equipe (opcional)",
      nomeColuna: "nome_time",
      tamanho: 70,
      tipo: Tipo.TEXTO,
    }),*/
  ];
  
  let cupomConfig = [
    new ItemInserir({
      rotulo: "Cupom promocional",
      nomeColuna: "codigo_cupom",
      obrigatorio: false, // Pode ser alterado por VerificaCupomObrigatorio
      tamanho: 100,
      tipo: Tipo.TEXTO_VALIDADO,
    }),
  ];
  let inscricaoItensConfig = [
    new ItemInserir({
      rotulo: "Nome",
      nomeColuna: "nome_usuario",
      tamanho: 100,
      tipo: Tipo.NOME_SOBRENOME,
      obrigatorio: true,
    }), 
   new ItemInserir({
      rotulo: "CPF",
      nomeColuna: "cpf",
      tamanho: 20,
      tipo: Tipo.CPF,
      obrigatorio: true,
    }),
    new ItemInserir({
      rotulo: "Email",
      nomeColuna: "email",
      tamanho: 500,
      tipo: Tipo.EMAIL,
      obrigatorio: true,
    })
   /*
    new ItemInserir({
      rotulo: "Nome do BOX (opcional)",
      nomeColuna: "box",
      tamanho: 70,
      tipo: Tipo.TEXTO,
      obrigatorio: false,
    }),
   
    new ItemInserir({
      rotulo: "Data de nascimento",
      nomeColuna: "data_nascimento",
      tamanho: 10,
      tipo: Tipo.DATA,
      obrigatorio: true,
    }),

    new ItemInserir({
      rotulo: "Gênero",
      nomeColuna: "genero",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,
        nome_coluna_saida: "genero",
        filtravel: false,
        itens: ["Masculino", "Feminino", "Outro"],
      },
    }),

    new ItemInserir({
      rotulo: "Camisa do primeiro dia",
      nomeColuna: "tamanho_camisa",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,
        parametros: {
          query_code: "consulta_generica_campeonato",
          tabela: "tamanhos_camisa",
          id_campeonato: id_campeonato,
        },
        nome_coluna_opcoes: "tamanho_roupa",
        nome_coluna_saida: "id",
        filtravel: true,
        itens: "",
      },

    }),new ItemInserir({
      rotulo: "Camisa do segundo dia",
      nomeColuna: "tamanho_camisa2",
      tamanho: 30,
      tipo: Tipo.SELECAO,
      obrigatorio: true,
      config_drop_down: {
        api: Constantes.api_consultar_padrao,
        parametros: {
          query_code: "consulta_generica_campeonato",
          tabela: "tamanhos_camisa",
          id_campeonato: id_campeonato,
        },
        nome_coluna_opcoes: "tamanho_roupa",
        nome_coluna_saida: "id",
        filtravel: true,
        itens: "",
      },

    }),
    new ItemInserir({
      rotulo: "Descreva sua deficiência e quais adaptações necessárias.",
      nomeColuna: "tipo_deficiencia",
      tamanho: 200,
      tipo: Tipo.TEXTO,
      obrigatorio: true,
    }),
     new ItemInserir({
      rotulo: "Nome do acompanhante",
      nomeColuna: "nome_acompanhante",
      tamanho: 200,
      tipo: Tipo.TEXTO,
      obrigatorio: true,
    }),*/
  ];

  // --- VARIÁVEIS DE ESTADO QUE ARMAZENAM OS ITENS FILTRADOS/PROCESSADOS ---
  // Inicialize-as imediatamente com base nas configurações originais
  let ArmazenaInscricaoItens = [...inscricaoItensConfig];
  let ArmazenaNomeTime = [...nomeTimeConfig];
  // CORREÇÃO AQUI: Inicialize 'cupom' diretamente de 'cupomConfig'
  let cupom = [...cupomConfig];
  let categoria = []; // Categoria será preenchida em setupRegistrationForm

  // --- Funções ---

  async function PegaDrops(e) {
    if (e.detail.nomeDrop && e.detail.nomeDrop.toLowerCase() == rotuloCategoria.toLowerCase()) {
      console.log("Categoria selecionada:", e.detail.objeto);
      rotuloAcordion = e.detail.objeto.rotulo_acordion;
      numeroAteltas = e.detail.objeto.numero_atleta_equipe;
      let cat = e.detail.objeto.id;

      await VerificaHabilitados(cat); // Atualiza ArmazenaInscricaoItens e ArmazenaNomeTime
      AjustaLista(); // Reconstroi totalItens com os novos Armazena... e numeroAteltas
    }
  }

  async function setupRegistrationForm() {
    carregando = true;
    aguardarCarregamentoInicial = false;

    // Define os itens da Categoria
    categoria = [
      new ItemInserir({
        nomeColuna: "id_campeonato",
        valor: id_campeonato,
        tipo: Tipo.HIDDEN,
      }),
      new ItemInserir({
        nomeColuna: "id_usuario",
        valor: ArmazenaVariaveisLogin.dados.id_usuario,
        tipo: Tipo.HIDDEN,
      }),
      new ItemInserir({
        rotulo: rotuloCategoria,
        nomeColuna: "categoria",
        tamanho: 30,
        tipo: Tipo.SELECAO,
        obrigatorio: true,
        config_drop_down: {
          api: Constantes.api_consultar_padrao,
          parametros: {
            query_code: "consulta_generica_campeonato",
            tabela: "categorias_campeonatos_exibe_so_lote_ativo_view",
            id_campeonato: id_campeonato,
          },
          nome_coluna_opcoes: "nome_categoria_completo",
          nome_coluna_saida: "id",
          filtravel: false,
          itens: "",
          nome_drop: rotuloCategoria,
        },
      }),
    ];

    // Reseta as listas armazenadas para as configurações originais antes de filtrar
    ArmazenaInscricaoItens = [...inscricaoItensConfig];
    ArmazenaNomeTime = [...nomeTimeConfig];
    // Inicializa cupom novamente com a config, garantindo que a obrigatoriedade seja verificada depois
    cupom = [...cupomConfig];


    await VerificaRotulo();
    //await VerificaCupomObrigatorio(); // Esta função AGORA modifica 'cupomConfig' e 'cupom'

    numeroAteltas = 0; // Define um padrão inicial
    AjustaLista(); // Constrói totalItens com 1 atleta e cupom obrigatório (se for o caso)

    carregando = false;
    aguardarCarregamentoInicial = true;
  }

  async function VerificaHabilitados(catId) {
    carregando = true;

    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "config_inscricao",
      id: catId,
    });

    // Usa as configurações originais para começar a filtrar para esta categoria
    let currentInscricaoItems = [...inscricaoItensConfig];
    let currentNomeTime = [...nomeTimeConfig];

    if (result && result.length > 0) {
      const colunasDesabilitadas = result.map((item) => item.nome_coluna);
      console.log("Colunas desabilitadas:", colunasDesabilitadas);

      currentInscricaoItems = currentInscricaoItems.filter(
        (item) => !colunasDesabilitadas.includes(item.nomeColuna)
      );
      currentNomeTime = currentNomeTime.filter(
        (item) => !colunasDesabilitadas.includes(item.nomeColuna)
      );
    }

    // Atualiza as variáveis armazenadas com a lista filtrada para a categoria selecionada
    ArmazenaInscricaoItens = currentInscricaoItems;
    ArmazenaNomeTime = currentNomeTime;

    carregando = false;
  }

  async function VerificaRotulo() {
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "consultar_campeonato",
      id_campeonato: id_campeonato,
    });

    if (result && result.length > 0) {
      rotuloCategoria = result[0].rotulo_categoria || "Categoria";
      tituloAcordion = result[0].titulo_acordion || "Inscrição";
      console.log("Título do Acordion:", tituloAcordion);
    }
  }

  async function VerificaCupomObrigatorio() {
    let result = await conexao.conecta(Constantes.api_consultar_padrao, {
      query_code: "cupom_obrigatorio",
      id_campeonato: id_campeonato,
    });

    // Encontra o item de cupom na configuração original para modificá-lo
    const cupomItemConfig = cupomConfig.find(item => item.nomeColuna === 'codigo_cupom');

    if (cupomItemConfig && result && result.length > 0) {
        cupomItemConfig.obrigatorio = true;
        console.log("Cupom definido como obrigatório.");
    } else if (cupomItemConfig) {
         cupomItemConfig.obrigatorio = false;
         console.log("Cupom não é obrigatório.");
    }
     // Atualiza a variável de estado 'cupom' com a configuração possivelmente modificada
    cupom = [...cupomConfig];
  }


   function AjustaLista() {
    let tempTotalItens = {};

    // Adiciona o Accordion da Categoria
    tempTotalItens[rotuloCategoria] = [...categoria]; // Copia a lista de itens da categoria

    // Adiciona o item Nome do Time ao Accordion da Categoria SE numeroAteltas > 1
     if (numeroAteltas > 1) {
        tempTotalItens[rotuloCategoria] = [...tempTotalItens[rotuloCategoria], ...ArmazenaNomeTime];
    }

    // Adiciona os Accordions dos Atletas
    for (let index = 1; index <= numeroAteltas; index++) {
      let labelIndex = (numeroAteltas === 1) ? "" : index;
      let athleteLabel = rotuloAcordion + labelIndex;

      // Cria NOVAS instâncias dos itens de inscrição para CADA atleta
      tempTotalItens[athleteLabel] = ArmazenaInscricaoItens.map((item) => {
        return new ItemInserir({
          ...item,
          valor: "", // Garante que cada atleta comece com campos vazios
        });
      });
    }

    // Adiciona o Accordion do Cupom SE houver pelo menos 1 atleta
    if (numeroAteltas > 0) {
       // Usa a variável de estado 'cupom', que já contém o ItemInserir configurado
       tempTotalItens["Cupom"] = [...cupom];
    } else {
       // Se não há atletas (e.g., tela inicial antes de selecionar categoria), remove o Cupom
       delete tempTotalItens["Cupom"];
    }


    // Atualiza a variável reativa totalItens
    totalItens = tempTotalItens;

    // Mantém apenas o primeiro accordion (Categoria) aberto por padrão
    AberturaAccordion = [rotuloCategoria];
  }


  function Resultado(e) {
    // 1. CHECA PRIMEIRO: Se a trava já foi acionada, saia imediatamente.
    if (!permite_chamar_navigate) {
      console.warn("Chamada duplicada de Resultado() ignorada.");
      return;
    }

    // 2. ACIONA A TRAVA: Define como false IMEDIATAMENTE.
    permite_chamar_navigate = false;

    // 3. EXECUTA A LÓGICA: Agora é seguro navegar.
    console.log("Permissão para navegar concedida. Travando...");
    let id_inscricao = e.detail.id_cod_inscricao;
    DadosPaginaAnterior.set({ id_campeonato: id_campeonato });
    //navigate(Constantes.tela_pre_pagamento + "?id=" + id_inscricao);

   window.location.href=Constantes.tela_pre_pagamento + "?id=" + id_inscricao;
}


  onMount(async () => {
    permite_chamar_navigate=true
    await params;
    id_campeonato = params;

    carregando = true;
    aguardarCarregamentoInicial = false;

    const userId = ArmazenaVariaveisLogin.dados.id_usuario;

    if (!userId) {
       console.warn("User not logged in. Skipping pending registration check.");
       // Se o usuário não está logado, não faz sentido verificar inscrições pendentes do usuário logado.
       // Procede direto para a configuração do formulário de inscrição.
       // Note: o formulário de inscrição deve ser capaz de lidar com usuário não logado
       // (por exemplo, coletando dados de contato se necessário, dependendo da sua lógica).
       await setupRegistrationForm();
       carregando = false;
       return;
    }

    try {
        const pendingCheckResult = await conexao.conecta(Constantes.api_consultar_padrao, {
            query_code: "consultar_minhas_inscricoes_nao_pagas",
            id_usuario: userId,
        });

        if (pendingCheckResult && pendingCheckResult.length > 0 && pendingCheckResult[0].tem_pendente) {
            console.log("Usuário tem inscrições pendentes.");
            showPendingMessage = true;
        } else {
             console.log("Usuário não tem inscrições pendentes. Procedendo com a inscrição.");
             showPendingMessage = false;
             await setupRegistrationForm(); // Procede para configurar o formulário
        }
    } catch (error) {
        console.error("Error checking for pending registrations:", error);
        // Em caso de erro na API, assume que não há pendências (ou não foi possível verificar)
        showPendingMessage = false;
        await setupRegistrationForm(); // Procede para configurar o formulário mesmo com erro
    } finally {
        carregando = false; // Finaliza o loading principal
    }

  });


  function goToMyRegistrations() {
      navigate(tela_minhas_inscricoes);
  }

  async function startNewRegistration() {
      showPendingMessage = false;
      await setupRegistrationForm(); // Chama a função para configurar e exibir o formulário
  }


  // Athlete counter logic commented out as per original request

</script>

<LoadingTela isLoading={carregando} />

<div class="container">
  <div class="row">

    <div class="col-md-6">
      {#if showPendingMessage}
        <div class="pending-message-card card p-4 shadow-sm text-center">
          <h3>Atenção!</h3>
          <p>Você tem créditos pendentes de pagamento.</p>
          <p>Por favor, finalize o pagamento dos creditos anteriores ou clique abaixo para iniciar uma nova compra.</p>
          <div class="d-grid gap-2">
            <button class="btn btn-primary" on:click={goToMyRegistrations}>
              Continuar compra
            </button>
            <button class="btn btn-outline-secondary" on:click={startNewRegistration}>
              Nova compra
            </button>
          </div>
        </div>
      {:else if aguardarCarregamentoInicial && permite_chamar_navigate}
         <InserirDadosAcordion
          possuiLoading={false}
          centralizado={true}
          on:retorna_drops={PegaDrops}
          titulo={"Compra de Créditos"}
          api={api_inscricao_campeonato}
          strong={true}
          itens={totalItens}
          botaoProsseguir={numeroAteltas < 1 ? false : true}
          query_code_carregar_edicao={query_code_carrega_dados_usuario_cadastrado}
          {AberturaAccordion}
          {parametrosInputValidacao}
          {apiInputValidacao}
          {voltarPagina}
          parametro_adicional={id_campeonato}
          parametro_adicional2={rotuloAcordion}
          mensagemDuplicado={Constantes.msg_inscricao_duplicada}
          on:sucesso|once={Resultado}
        >
        
        </InserirDadosAcordion>
      {/if}
    </div>

   

  </div>
</div>

<style>
  .pending-message-card {
      border: 1px solid #ffc107;
      background-color: #fff3cd;
  }

  .btn-decremento, .btn-incremento {
    background-color: #007bff;
    color: white;
    font-size: 20px;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 5px;
    transition: background-color 0.3s;
  }

  .btn-decremento:disabled, .btn-incremento:disabled {
    background-color: #aaa;
    cursor: not-allowed;
  }

  .btn-decremento:hover:not(:disabled), .btn-incremento:hover:not(:disabled) {
    background-color: #0056b3;
  }

  .valor {
    font-size: 18px;
    font-weight: bold;
    width: 50px;
    text-align: center;
  }
  .padraoAviso {
      background-color: #d6eaf8;
      text-align: center;
      padding: 10px;
      border-radius: 5px;
      margin-top: 20px;
  }
    .padraoAviso i {
        font-size: 0.9em;
    }

  .container {
    max-width: 1280px;
    margin: 50px auto;
    padding: 1rem;
  }

  .card-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 100px);
  }

  .card {
    width: 300px;
    text-align: center;
  }
  .imagem {
    max-width: 100%;
  }
  textarea#regulamento {
    height: 150px;
    overflow-y: auto;
  }
  .add-remove-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .rounded-circle {
    width: 40px;
    height: 40px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
    border: 1px solid #dee2e6;
    margin: 10px;
  }

  .rounded-circle:hover {
    background-color: #f8f9fa;
  }
</style>